import { Component, Input } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';

export type InfoBoxType = 'info' | 'warning' | 'error';

@Component({
  selector: 'app-status-bar',
  imports: [NgClass, NgIf],
  templateUrl: './status-bar.component.html',
  styleUrl: './status-bar.component.css',
  standalone: true,
})
export class StatusBarComponent {
  @Input() type: InfoBoxType = 'info';
  @Input() icon?: string;
}
